<template>
  <div>
    <input @click.stop class="mb8 filter-inp" placeholder="输入关键字进行过滤" v-model="filterText" />
    <div class="scrollbar">
      <el-scrollbar ref="scrollbar">
        <el-tree
          ref="tree"
          :data="stageData"
          node-key="id"
          show-checkbox
          :filter-node-method="filterNode"
          :default-expanded-keys="checkedKeys"
          :default-checked-keys="checkedKeys"
          @check-change="handleRadioCheckChange"
          :render-content="renderContent"
        >
        </el-tree>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
import { componentNames } from "dependencies/base"
import { isExist } from "utils"
export default {
  props: {
    checkedIds: {
      type: null
    },
    // 单选还是多选，true为单选，false为多选
    showRadio: {
      type: Boolean,
      default: true
    },
    isShow: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val)
    },
    isShow(val) {
      if (val) {
        this.$nextTick(() => {
          this.toFirstCheckedKey()
        })
      }
    }
  },
  computed: {
    checkedKeys() {
      if (!this.checkedIds) {
        return []
      }
      return [this.checkedIds.id]
    }
  },
  data() {
    return {
      stageData: [],
      hoverEl: null,
      filterText: ""
    }
  },
  methods: {
    // 定位到选中的第一个组件
    toFirstCheckedKey() {
      if (this.checkedKeys.length === 0) {
        return
      }
      let ids = this.checkedIds.ids
      let rectIds
      if (isExist(ids.elementInAutoLayoutId)) {
        rectIds = `container_id_${ids.container_id}-rect_id_${ids.rect_id}-elementInAutoLayoutId_${ids.elementInAutoLayoutId}-path_${ids.path}`
      } else {
        rectIds = `container_id_${ids.container_id}-rect_id_${ids.rect_id}`
      }
      let dom = document.querySelectorAll(`[data-cxid=${rectIds}]`)
      let domTop = dom[0].getBoundingClientRect().top - this.$refs.scrollbar.$el.getBoundingClientRect().top
      this.$el.getElementsByClassName("el-scrollbar__wrap")[0].scrollTo({ top: domTop, behavior: "smooth" })
    },
    filterNode(value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },
    clearHoverEl() {
      if (this.hoverEl) this.hoverEl.classList.remove("hover-item")
    },
    renderContent(h, { node, data, store }) {
      if (data.id) {
        return (
          <span data-cxid={data.id}>
            <span class="mr8">{data.label}</span>
          </span>
        )
      } else {
        return (
          <span class="custom-content">
            <span class="mr8">{data.label}</span>
          </span>
        )
      }
    },
    // 单选
    chooseRect(data) {
      this.clearHoverEl()
      this.$emit("update:checkedIds", [{ ...data.ids }])
    },
    mouseoverItem(data) {
      const ids = { ...data.ids }
      delete ids.pageId
      let idsStr
      if (data.label === "单元格") {
        idsStr = `componentBox_after${data.ids.uid}`
      } else {
        idsStr = this.$event.getIdsByStrId(ids)
      }
      this.clearHoverEl()
      this.hoverEl = document.getElementsByClassName(idsStr)[0]
      if (this?.hoverEl?.classList && !this.hoverEl.classList.contains("hover-item")) {
        this.hoverEl.classList.add("hover-item")
      }
    },
    handleRadioCheckChange(data, status) {
      // 执行单选操作
      if (!status && this.checkedKeys[0] === this.$event.getIdsByStrId(data.ids)) {
        this.$refs.tree.setChecked(data, true)
      }
      this.clearHoverEl()
      if (status && this.checkedKeys[0] !== this.$event.getIdsByStrId(data.ids)) {
        this.$refs.tree.setCheckedKeys([])
        this.$refs.tree.setChecked(data, true)
        this.$emit("update:checkedIds", data)
      }
    },
    formateLayoutTitleComponent(data, rectIds, res = []) {
      let element = []
      data.forEach((item, index) => {
        if (item.isShow) {
          item.elementOptions.forEach(rect => {
            if (!rect.isShow) {
              return
            }
            const elementInLayoutIds = {
              ...rectIds,
              directionIndex: index,
              elementInLayoutId: rect.elementInLayoutId
            }
            element.push({
              label: componentNames[rect.innerElement],
              ids: elementInLayoutIds,
              id: this.$event.getIdsByStrId(elementInLayoutIds)
            })
          })
        }
      })
      if (element.length > 0) {
        res.push({
          label: "边栏",
          children: element
        })
      }
      return res
    },
    formateLayoutComponent(data, rectIds, res = []) {
      data.forEach(item => {
        if (item.height) {
          const rowData = { label: "行" }
          if (item?.cols?.length) {
            rowData.children = item.cols ? this.formateLayoutComponent(item.cols, rectIds) : []
            res.push(rowData)
          }
        } else if (item.width) {
          const colData = { label: "列" }
          if (item?.rows?.length) {
            colData.children = item.rows ? this.formateLayoutComponent(item.rows, rectIds) : []
            res.push(colData)
          } else if (item.elementOptions.length) {
            let elementRes = []
            res.push({
              label: "单元格",
              ids: { ...rectIds, uid: item.uid },
              id: this.$event.getIdsByStrId({
                ...rectIds,
                uid: item.uid
              })
            })
            item.elementOptions.forEach(elementInLayout => {
              const elementInLayoutIds = {
                ...rectIds,
                uid: item.uid,
                elementInLayoutId: elementInLayout.elementInLayoutId
              }
              res.push({
                label: componentNames[elementInLayout.innerElement],
                ids: elementInLayoutIds,
                id: this.$event.getIdsByStrId({
                  ...rectIds,
                  uid: item.uid,
                  elementInLayoutId: elementInLayout.elementInLayoutId
                })
              })
            })
          }
        }
      })
      return res
    },
    formateAutoLayoutComponent(data, rectIds, res = []) {
      data.forEach(item => {
        if (item.innerElement === "cxAutoLayout") {
          res = this.formateAutoLayoutComponent(item.elementOptions, rectIds, res)
        } else {
          if (item?.elementOptions) {
            res = this.formateAutoLayoutComponent(item.elementOptions, rectIds, res)
          }
          let itemChildren = []
          if (item.innerElement.toLowerCase().includes("layout") && item.rows) {
            const childIds = {
              ...rectIds,
              elementInAutoLayoutId: item.elementInAutoLayoutId,
              path: item.path
            }
            itemChildren = this.formateLayoutTitleComponent(item.titleOptions, childIds)
            let children = this.formateLayoutComponent(item.rows, childIds)
            itemChildren = itemChildren.concat(children)
          }
          res.push({
            children: itemChildren,
            label: componentNames[item.innerElement],
            ids: {
              ...rectIds,
              elementInAutoLayoutId: item.elementInAutoLayoutId,
              path: item.path
            },
            id: this.$event.getIdsByStrId({
              ...rectIds,
              elementInAutoLayoutId: item.elementInAutoLayoutId,
              path: item.path
            })
          })
        }
      })
      return res
    },
    formateSwiperComponent(swiperPages, rectIds) {
      return swiperPages.map((page, index) => {
        return page.elementOptions.length
          ? {
              label: "轮播页" + index,
              children: page.elementOptions.map(elementInSwiper => {
                return {
                  label: componentNames[elementInSwiper.innerElement],
                  ids: {
                    ...rectIds,
                    elementInSwiperId: elementInSwiper.elementInSwiperId,
                    swiperContent_id: page.swiperContent_id
                  },
                  id: this.$event.getIdsByStrId({
                    ...rectIds,
                    elementInSwiperId: elementInSwiper.elementInSwiperId,
                    swiperContent_id: page.swiperContent_id
                  })
                }
              })
            }
          : { label: "轮播页" + index }
      })
    },
    initStageData() {
      const res = []
      const stage = this.$store.state[this.request_prefix]
      const container = stage.page.children[0]
      const containerId = container.container_id
      const containerIds = { container_id: containerId }
      const containerData = {}
      if (container.children.length) {
        containerData.children = []
        for (let j = 0; j < container.children.length; j++) {
          const rect = container.children[j]
          const shape = rect.shape || rect.innerElement
          const rectIds = { rect_id: rect.rect_id, ...containerIds }
          let label = componentNames[shape]
          if (!label && rect.options.innerElement === "swiperComponent") {
            label = "轮播"
          }
          let rectData = {
            label: label,
            ids: rectIds,
            id: this.$event.getIdsByStrId(rectIds)
          }
          // 比如页面滚动到某个组件的位置
          if (shape.toLowerCase().includes("autolayout")) {
            //处理自动布局组件内的组件格式化为属性组件数据格式
            let children = rect.options.elementOptions
              ? this.formateAutoLayoutComponent(rect.options.elementOptions, rectIds)
              : []
            rectData = children
          }
          if (!this.showRadio) {
            if (shape.toLowerCase().includes("layout")) {
              //处理自由布局组件内的组件格式化为属性组件数据格式
              rectData.children = rect.options.rows
                ? this.formateLayoutTitleComponent(rect.options.titleOptions, rectIds)
                : []
              let children = rect.options.rows ? this.formateLayoutComponent(rect.options.rows, rectIds) : []
              rectData.children = rectData.children.concat(children)
            } else if (shape.toLowerCase().includes("swiper")) {
              //处理轮播2组件内的组件格式化为属性组件数据格式
              rectData.children = rect.options.content ? this.formateSwiperComponent(rect.options.content, rectIds) : []
            }
          }
          if (Array.isArray(rectData)) {
            containerData.children = containerData.children.concat(rectData)
          } else {
            containerData.children.push(rectData)
          }
        }
      }
      res.push(containerData)
      this.stageData = res[0].children
    },
    changeHover(event) {
      let target = event.target
      while (target.className.indexOf("el-tree-node__content") === -1) {
        target = target.parentElement
      }
      if (!target) {
        return
      }
      const menuItem = target.lastChild
      if (menuItem.hasAttribute("data-cxid")) {
        const id = menuItem.getAttribute("data-cxid")
        const data = this.findNode(this.stageData, id)
        this.mouseoverItem(data)
      } else {
        this.clearHoverEl()
      }
    },
    findNode(tree, id) {
      for (const node of tree) {
        if (node.id === id) {
          return node
        }
        if (node.children) {
          const found = this.findNode(node.children, id)
          if (found) {
            return found
          }
        }
      }
      return null
    }
  },
  mounted() {
    this.initStageData()
    this.$refs.tree.$el.addEventListener("mouseover", this.changeHover)
  },
  beforeDestroy() {
    this.clearHoverEl()
    this.$refs.tree.$el.removeEventListener("mouseover", this.changeHover)
  }
}
</script>

<style>
.filter-inp {
  height: 32px;
  border-radius: 4px;
  background-color: #f3f3f3;
  width: 100%;
  padding: 0 10px;
}
.hover-item {
  opacity: 1;
}
.hover-item::after {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  content: "";
  opacity: 0.5;
  background: rgba(16, 245, 119, 1);
  z-index: 9999;
}
</style>
<style scoped>
.scrollbar {
  height: 400px;
  overflow: hidden;
}
::v-deep .el-scrollbar {
  height: 100%;
}
::v-deep .el-scrollbar__wrap {
  overflow-y: scroll;
  overflow-x: scroll;
  height: calc(100% + 16px);
  margin-bottom: 0 !important;
}
::v-deep .scrollbar .el-scrollbar__view {
  margin-bottom: 16px;
}
::v-deep .el-tree-node__content:hover {
  background-color: var(--elTreeHoverColor) !important;
  color: var(--elCollapseItemContentColor);
}
::v-deep .is-current > .el-tree-node__content {
  background-color: rgba(23, 112, 255, 0.5) !important;
}
::v-deep .el-tree-node__content {
  background: var(--elCollapseItemWrapBgColor) !important;
}
::v-deep .el-tree {
  background: var(--elCollapseItemWrapBgColor) !important;
  color: var(--elCollapseItemContentColor);
}
::v-deep .el-tree-node.is-checked .el-tree-node__children {
  display: none !important;
}
::v-deep .el-tree-node input[type="radio"]:checked {
  border: 2px solid red;
}

::v-deep .custom-content span {
  display: inline-block;
  line-height: 21px;
}
::v-deep .custom-content {
  background-color: #fff;
  height: 21px;
  position: relative;
  left: -22px;
  z-index: 4;
  width: 100%;
}
::v-deep .el-tree-node__content:hover .custom-content span {
  display: inline-block;
  background-color: var(--elTreeHoverColor) !important;
  color: var(--elCollapseItemContentColor);
  width: 100%;
}
::v-deep .is-current > .el-tree-node__content .custom-content span {
  background-color: rgba(23, 112, 255, 0.5) !important;
  display: inline-block;
  width: 100%;
}
::v-deep
  .el-tree-node__children
  .el-tree-node__children
  .el-tree-node__children
  .el-tree-node__children
  .el-tree-node__content {
  margin-left: -16px;
}
</style>
